var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"frameborder":"0","id":"detailFrame","scrolling":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }